<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="staff.Username" ref="username" label="User Name" class="input-group--focused" :rules="nameRules" error-count="2"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-text-field v-model="staff.Email" label="Email" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-text-field v-model="staff.FullName" label="Họ tên" class="input-group--focused"></v-text-field>
                </v-flex>
                <!-- <v-flex lg12 md12 sm12>
                    <v-select v-model="staff.RoleID" :items="role_list" item-text="name" item-value="value" label="Quyền hạn" class="input-group--focused"></v-select>
                </v-flex> -->
                <v-flex lg12 md12 sm12>
                    <div class="subtitle-2 mb-4">Quyền hạn</div>
                </v-flex>
                <v-divider></v-divider>
                <v-flex lg4 md6 sm12><v-switch v-model="roleEdit.admin" label="Admin" class="input-group--focused"></v-switch></v-flex>
                <v-flex lg4 md6 sm12><v-switch v-model="roleEdit.manager" label="Quản lý" class="input-group--focused" :disabled="roleEdit.admin == true"></v-switch></v-flex>
                <v-flex lg4 md6 sm12><v-switch v-model="roleEdit.payment" label="Kế toán" class="input-group--focused" :disabled="roleEdit.admin == true"></v-switch></v-flex>
                <v-flex lg4 md6 sm12><v-switch v-model="roleEdit.purchase" label="Mua hàng" class="input-group--focused" :disabled="roleEdit.admin == true"></v-switch></v-flex>
                <v-flex lg4 md6 sm12><v-switch v-model="roleEdit.customerService" label="Chăm sóc KH" class="input-group--focused" :disabled="roleEdit.admin == true"></v-switch></v-flex>
                <v-flex lg4 md6 sm12><v-switch v-model="roleEdit.sale" label="Sale" class="input-group--focused" :disabled="roleEdit.admin == true"></v-switch></v-flex>
                <v-flex lg4 md6 sm12><v-switch v-model="roleEdit.officer" label="Chứng từ" class="input-group--focused" :disabled="roleEdit.admin == true"></v-switch></v-flex>
                <v-flex lg4 md6 sm12><v-switch v-model="roleEdit.storeVN" label="Kho VN" class="input-group--focused" :disabled="roleEdit.admin == true"></v-switch></v-flex>
                <v-flex lg4 md6 sm12><v-switch v-model="roleEdit.storeCN" label="Kho TQ" class="input-group--focused" :disabled="roleEdit.admin == true"></v-switch></v-flex>
                <v-flex lg12 md12 sm12 v-if="roleEdit.sale">
                    <div class="subtitle-2 mt-4 mb-4">Cấu hình Sale Leader</div>
                </v-flex>
                <v-flex lg12 md12 sm12 v-if="roleEdit.sale">
                    <v-divider></v-divider>
                </v-flex>
                <v-flex lg12 md12 sm12 v-if="roleEdit.sale">
                    <v-switch
                        v-model="staff.IsSaleLeader"
                        :true-value="1"
                        :false-value="0"
                        label="Sale Leader"
                        class="input-group--focused"
                    ></v-switch>
                </v-flex>
                <v-flex lg12 md12 sm12 v-if="canAssignSaleMembers">
                    <v-autocomplete
                        v-model="selectedSaleMemberIds"
                        :items="saleMemberOptions"
                        item-text="DisplayName"
                        item-value="ID"
                        label="Thành viên sale thuộc quyền quản lý"
                        multiple
                        chips
                        deletable-chips
                        clearable
                        class="input-group--focused"
                    ></v-autocomplete>
                </v-flex>
                <!-- <v-flex lg12 md12 sm12 v-if="roleEdit.customerService">
                    <v-select v-model="staff.ReceivePlaceID" :items="warehouses" item-text="Name" item-value="ID" label="Kho hàng" class="input-group--focused"></v-select>
                </v-flex> -->
                <v-flex lg12 md12 sm12></v-flex>
                <v-flex lg4 md4 sm12>
                    <v-text-field v-model="staff.AffCode" label="Mã giới thiệu" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg4 md4 sm12>
                    <v-select v-model="staff.is_active" :items="status_list" item-text="name" item-value="value" label="Trạng thái" class="input-group--focused"></v-select>
                </v-flex>
                <v-flex lg4 md4 sm12>
                    <v-text-field v-model="staff.CommissionRate" label="Hoa hồng doanh thu (%)" class="input-group--focused" v-if="roleEdit.purchase || roleEdit.customerService" type="number"></v-text-field>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import md5 from "md5";
import configs from "../../configs";
import { sendErrorNotice } from "@/commons/utils";
export default {
    data() {
        let roles = this.$store.state.roles.all.data.map(obj =>{ 
            var rObj = {};
            rObj['value'] = obj.ID;
            rObj['name'] = obj.RoleName;
            return rObj;
        });
        return {
            firstLoad: true,
            isSaving: false,
            selectedSaleMemberIds: [],
            role_list: roles,            
            roleEdit: {
                admin: false,
                manager: false,
                purchase: false,
                customerService: false,
                storeVN: false,
                storeCN: false,
                payment: false,
                sale: false,
                officer: false
            },
            nameRules: [
                v => (v || '').indexOf(' ') < 0 || 'Tên đăng nhập không được chứa dấu cách',
                v => !(/(?=.*[A-Z])/.test(v)) || 'Tên đăng nhập không được viết hoa',
                v => /^[\x00-\x7F]*$/.test(v) || 'Tên đăng nhập chỉ bao gồm chữ cái a-z và số 0-9',
            ],
            status_list: [
                { value: 1, name: 'Kích hoạt' },
                { value: 0, name: 'Chưa kích hoạt' }
            ]
        }
    },
    computed: {
        ...mapState({
            loading: state => state.staff.loading,
            staff: state => state.staff.selected,
            warehouses: state => state.commons.stores,
            allUsers: state => state.commons.all_users,
        }),
        modifyId() {
            return this.$route.params.Pid;
        },
        csRoleID() {
            return configs.ROLE_TYPE.CustomerService;
        },
        canAssignSaleMembers() {
            return this.roleEdit.sale && Number(this.staff.IsSaleLeader || 0) === 1;
        },
        saleMemberOptions() {
            const currentId = Number(this.staff.ID || 0);
            return this.allUsers
                .filter(user => {
                    const isSale = (user.RoleType & configs.ROLE_TYPE.Sale) == configs.ROLE_TYPE.Sale;
                    return isSale && Number(user.ID) !== currentId;
                })
                .map(user => ({
                    ...user,
                    DisplayName: Number(user.IsSaleLeader || 0) === 1 ? `${user.FullName} (Leader)` : user.FullName
                }));
        },
        previousSaleMemberIds() {
            const currentId = Number(this.staff.ID || 0);
            if (currentId <= 0) {
                return [];
            }
            return this.allUsers
                .filter(user => Number(user.SaleLeaderID || 0) === currentId)
                .map(user => Number(user.ID));
        },
    },
    watch: {
        modifyId() {
            this.refreshData();
        },
        allUsers() {
            this.syncSelectedSaleMembers();
        },
        staff() {
            if(this.firstLoad){                
                this.firstLoad = false;
                this.roleEdit.admin = (this.staff.RoleType & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
                this.roleEdit.manager = (this.staff.RoleType & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager;
                this.roleEdit.purchase = (this.staff.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
                this.roleEdit.customerService = (this.staff.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
                this.roleEdit.storeVN = (this.staff.RoleType & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
                this.roleEdit.storeCN = (this.staff.RoleType & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
                this.roleEdit.payment = (this.staff.RoleType & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
                this.roleEdit.sale = (this.staff.RoleType & configs.ROLE_TYPE.Sale) == configs.ROLE_TYPE.Sale;
                this.roleEdit.officer = (this.staff.RoleType & configs.ROLE_TYPE.Officer) == configs.ROLE_TYPE.Officer;
                this.$set(this.staff, 'IsSaleLeader', Number(this.staff.IsSaleLeader || 0));
                this.syncSelectedSaleMembers();
            }
        },
        'roleEdit.sale'(val) {
            if (!val) {
                this.$set(this.staff, 'IsSaleLeader', 0);
                this.selectedSaleMemberIds = [];
            }
        },
        roleEdit: {
            handler: function (val, oldVal) {
                if(!this.firstLoad) {
                    this.staff.RoleType = 0;
                    if(val.admin) {
                        this.staff.RoleType = this.staff.RoleType | configs.ROLE_TYPE.Admin;
                    }
                    else if(val.manager) {
                        this.staff.RoleType = this.staff.RoleType | configs.ROLE_TYPE.Manager;
                    }
                    else if(val.sale) {
                        this.staff.RoleType = this.staff.RoleType | configs.ROLE_TYPE.Sale;
                    }
                    else if(val.officer) {
                        this.staff.RoleType = this.staff.RoleType | configs.ROLE_TYPE.Officer;
                    }
                    else {
                        if(val.purchase) {
                            this.staff.RoleType = this.staff.RoleType | configs.ROLE_TYPE.Purchase;
                        }
                        if(val.customerService) {
                            this.staff.RoleType = this.staff.RoleType | configs.ROLE_TYPE.CustomerService;
                        }
                        if(val.storeVN) {
                            this.staff.RoleType = this.staff.RoleType | configs.ROLE_TYPE.StoreVN;
                        }
                        if(val.storeCN) {
                            this.staff.RoleType = this.staff.RoleType | configs.ROLE_TYPE.StoreTQ;
                        }
                        if(val.payment) {
                            this.staff.RoleType = this.staff.RoleType | configs.ROLE_TYPE.Payment;
                        }
                        if(val.config) {
                            this.staff.RoleType = this.staff.RoleType | configs.ROLE_TYPE.Config;
                        }
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        syncSelectedSaleMembers() {
            const currentId = Number(this.staff.ID || 0);
            if (currentId <= 0) {
                this.selectedSaleMemberIds = [];
                return;
            }
            this.selectedSaleMemberIds = this.allUsers
                .filter(user => Number(user.SaleLeaderID || 0) === currentId)
                .map(user => Number(user.ID));
        },
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("staff/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("staff/setDetail", { data: {
                        ID: 0,
                        Username: '',
                        Email: '',
                        Password: md5('123456'),
                        RoleType: 0,
                        IsSaleLeader: 0,
                        SaleLeaderID: null,
                        ReceivePlaceID: 1,
                        is_active: 0,
                        is_admin: 0
                    }
                })
            }
            this.$nextTick(() => this.$refs.username.focus());
        },
        async saveData() {
            if (this.isSaving) {
                return;
            }
            this.isSaving = true;
            const payload = {
                ...this.staff,
                IsSaleLeader: this.canAssignSaleMembers ? 1 : 0,
                SaleMemberIDs: this.canAssignSaleMembers ? this.selectedSaleMemberIds : [],
            };
            if (!this.roleEdit.sale) {
                payload.IsSaleLeader = 0;
                payload.SaleLeaderID = null;
                payload.SaleMemberIDs = [];
            }
            try {
                await this.$store.dispatch("staff/setDetail", {
                    data: payload,
                    id: this.staff.ID
                });
                window.getApp.$emit("APP_NAVIGATE", "StaffList");
            }
            catch (e) {
                sendErrorNotice("Không thể lưu thông tin nhân viên.");
            }
            finally {
                this.isSaving = false;
            }
        },
    },
    mounted() {
        this.$store.dispatch("commons/getAllStores");
        this.$store.dispatch("commons/getAllUsers");
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.staff.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>
